import React from 'react'
import { injectIntl } from 'react-intl'
import { PageWrapper } from '../containers/PageWrapper'

const NoMatchPage = () => {
  const contentHeaderConfig = {}

  return (
    <PageWrapper contentHeaderConfig={contentHeaderConfig}>...</PageWrapper>
  )
}

NoMatchPage.propTypes = {}

export default injectIntl(NoMatchPage)

/*
export default PageWrapper({
  pageTitle: 'Load.AutomationWorkflow.ExistingFilterActivityPlaceholder',
  actionConfig,
  breadcrumbItems,
  topMenuConfigId,
  topMenuActiveId,
})(injectIntl(NoMatchPage));
*/
